import { WaterBody } from '@deckee/utilities';
import type { WeatherGraphPoint } from './riskLevels';

/**
 * Decides whether a location is rated as open coast or inland.
 *
 * The split is on whether the feed carries a swell forecast for this location
 * at all. A location that returns swell readings is coastal even when today's
 * swell happens to be flat — a 0 m reading is a real measurement of a calm sea,
 * not an absence of one. Only when there is no swell series does the location
 * fall back to the inland treatment, where the sea is the wind's own chop.
 */
export const resolveWaterBody = (
  swellHeightPoints: WeatherGraphPoint[] | null | undefined,
): WaterBody =>
  swellHeightPoints && swellHeightPoints.length > 0
    ? WaterBody.Coast
    : WaterBody.Inland;
